



























































































































import Vue from 'vue';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { phone } from '@/validations';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';

import { CloseFullscreenWrapper, FormValidation, OpenHelp, TriggerRefreshError } from '@/mixins';

import {
  FullscreenWrapper,
  FullscreenLoading,
  FullscreenSuccess,
  FullscreenError,
} from '@/components/fullscreen-wrapper-components';
import { api, MEMBER_API_SUB_URLS } from '@/api';
import { ExtendMixins } from '@/services';
import { MemberPersonalInformationResponseModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  sucessMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  refreshError: boolean;
  confirmBeforeClose: boolean;
  changeMade: boolean;
  formModel: any;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  OpenHelp,
  TriggerRefreshError,
).extend({
  name: 'UpdatePhone',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      sucessMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      refreshError: false,
      confirmBeforeClose: true,
      changeMade: false,
      formModel: {},
    };
  },
  validations: {
    formModel: {
      token: {
        required,
      },
      phoneNumberPrimary: {
        required,
        validPhoneLength: phone.validPhoneLength,
        validPhone: phone.validPhone,
      },
      isMobilePrimary: {},
      phoneNumberAlternate: {
        required: requiredIf((vm: any) => {
          return vm.isMobileAlternate;
        }),
        validPhoneLength: phone.validPhoneLength,
        validPhone: phone.validPhone,
      },
      isMobileAlternate: {},
    },
  },
  beforeMount() {
    this.formModel = JSON.parse(JSON.stringify(this.personalInformation));
    this.constructShowErrorModel('formModel');
  },
  computed: {
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },

    // VALIDATIONS
    tokenErrors(): string[] {
      const formField = 'formModel.token';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'global_form-error_token_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    primaryPhoneErrors(): string[] {
      const formField = 'formModel.phoneNumberPrimary';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-phone_form-error_primary-phone_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-phone_form-error_primary-phone_invalid-length',
            'global_form-error_phone-invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'validPhoneLength',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-phone_form-error_primary-phone_invalid-format',
            'global_form-error_phone-invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'validPhone',
        ),
      ]);
    },
    altPhoneErrors(): string[] {
      const formField = 'formModel.phoneNumberAlternate';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-phone_form-error_alt-phone_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-phone_form-error_alt-phone_invalid-length',
            'global_form-error_phone-invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'validPhoneLength',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-phone_form-error_alt-phone_invalid-format',
            'global_form-error_phone-invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'validPhone',
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      if (this.errorMessage === this.params.errorMessageTokenInvalid) {
        // We need user to start over and request a new token
        this.closeFullscreenWrapper();
        return;
      }
      this.showErrorMessage = false;
      this.confirmBeforeClose = true;
      this.errorMessage = this.params.errorMessage;
    },
    constructPayload(): any {
      return {
        phoneNumberPrimary: InputMaskTypes.phone.deconstruct(
          this.formModel.phoneNumberPrimary,
        )
          ? InputMaskTypes.phone.deconstruct(this.formModel.phoneNumberPrimary)
          : null,
        isMobilePrimary: this.formModel.isMobilePrimary,
        phoneNumberAlternate: this.formModel.phoneNumberAlternate
          ? InputMaskTypes.phone.deconstruct(
              this.formModel.phoneNumberAlternate,
            )
          : null,
        isMobileAlternate: this.formModel.isMobileAlternate,
      };
    },
    updatePhone(): void {
      this.isLoading = true;
      api
        .put(
          `${MEMBER_API_SUB_URLS.members}/${
            this.$store.getters.user.memberId
          }/profiles/phones`,
          this.constructPayload(),
          {
            headers: {
              'x-token': this.formModel.token,
            },
          },
        )
        .then(() => {
          this.refreshPersonalInformation();

          // GTM Event - Update Phone
          window.dataLayer.push({
            event: 'updatePhone',
          });
        })
        .catch((error) => {
          if (error.status === 403) {
            this.errorMessage = this.params.errorMessageTokenInvalid;
          }

          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshPersonalInformation(): void {
      this.$store
        .dispatch('getPersonalInformation')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'update-phone_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenLoading,
    FullscreenSuccess,
    FullscreenError,
  },
});
